export const transformationYaml = () => `id: "||VARIABLE_KEY_id||"
index: "||VARIABLE_KEY_index||"
name: "||VARIABLE_KEY_name||"
description: ""
type: 
metadata: `;
export const transformationTypesTemplate = () => [
  {
    type: 'Rename',
    metadataSample: {
      old_name: 'old_field',
      new_name: 'new_field',
    },
  },
  {
    type: 'BulkRename',
    metadataSample: [
      {
        old_name: 'old_field_1',
        new_name: 'new_field_1',
      },
      {
        old_name: 'old_field_2',
        new_name: 'new_field_2',
      },
    ],
  },
  {
    type: 'SQL',
    metadataSample: {
      sql: `SELECT 
          v.old_field1                        AS new_field_1,
          v.old_field2                        AS new_field_2
        FROM __hss_the_current_task_table v
        where v.__id = @__id`,
    },
  },
  {
    type: 'Nested_SQL',
    metadataSample: {
      field_name: 'the_nested_field_name',
      sql: `SELECT 
  v.old_field1                        AS new_field_1,
  v.old_field2                        AS new_field_2
FROM __hss_the_nested_task_table v
where exists (
  select 1 
  from __hss_the_current_task_table c 
  where 
    c.key_field = v.reference_field
    and c.__id = @__id
)`,
    },
  },
  {
    type: 'Clone',
    metadataSample: {
      field_name: 'field_name',
      new_names: ['new_field_name_1', 'new_field_name_2'],
    },
  },
  {
    type: 'BulkClone',
    metadataSample: [
      {
        old_name: 'old_field_1',
        new_name: 'new_field_1',
      },
      {
        old_name: 'old_field_2',
        new_name: 'new_field_2',
      },
    ],
  },
  {
    type: 'Jsonata',
    metadataSample: {
      field_name: 'field_name',
      expression: `(
  $new_field_name := $replace(old_field_name, /^(#)/, "");
)`,
    },
  },
  {
    type: 'Scriban',
    metadataSample: {
      field_name: 'field_name',
      expression: `{{
  new_field_name_1 = old_field_name | replace: "#", ""
}}
`,
    },
  },
];
